import { render, staticRenderFns } from "./InventoryIndex.vue?vue&type=template&id=666f5c34"
import script from "./InventoryIndex.vue?vue&type=script&lang=js"
export * from "./InventoryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports